import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { getApiBaseUrl } from '../../utils/utils'; 
export default function AddAttendance() {

    const API_URL = process.env.REACT_APP_API_URL;
    const [msg, setMsg] = useState('')
    const [errormsg, setError] = useState('')
    const navigate = useNavigate();


  



    const [searchQuery, setSearchQuery] = useState("");

    const [partners, setPartners] = useState([]);
    useEffect(() => {
        const fetchPartners = async () => {

            const baseApiUrl = getApiBaseUrl();
            try {
                const response = await axios.get(`${baseApiUrl}/v1.0/partner/retrieve_list?page=0`);
                setPartners(
                    (response.data.data || [])
                );

            } catch (err) {
                setError(err.message || 'Error fetching data');
            } finally {
                // setLoading(false);
            }
        };

        fetchPartners();
    }, []);

    const [selectedPartner, setSelectedPartner] = useState('0');




    const [settings, setSettings] = useState({
        require_attendance: false,
        login_logout_required: false,
        logout_anywhere_allowed: false,
        geo_restriction_enabled: false,
        multiple_locations_allowed: false,
        locations: [],
        drivers: []
    });

    useEffect(() => {
        // Fetch drivers from the API on component mount
        fetchDrivers();
        getUserList();
        // getHomebaseList();

    }, []);

    console.log(settings)



    const [homebases, sethomebases] = useState([])




    const locationOptions = homebases.map((homebase) => ({
        value: homebase.id, // or homebaseName if you prefer
        label: homebase.name,
    }));


    const getUserList = async () => {
        const API_PATH = `${API_URL}shypvdriverapp/partner-warehouse`;

        try {
            const res = await axios.get(API_PATH);
            console.log(res.data);
            if (res.data.success == true) {
                sethomebases(res.data.data);
            } else {
                console.log('false')
            }

        } catch (err) {
            console.log(err);
        }
    };



    const [drivers, setDrivers] = useState()
    const fetchDrivers = async () => {
        try {
            // Replace this API endpoint with the actual one that fetches drivers based on the emirate
            const response = await axios.get(`${API_URL}shypvdriverapp/driver/getAllDrivers`);

            if (response.data.success) {
                const driversData = response.data.data;  // The array of driver objects

                // Map the response to extract driverId and name
                const driversList = driversData.map(driver => ({
                    driver_id: driver.driverId,
                    driver_name: driver.name
                }));

                // Set the drivers state
                setDrivers(driversList);
            } else {
                console.error('Error fetching drivers for emirate:');
            }
        } catch (error) {
            console.error('Error fetching drivers:', error);
        }
    };


    const filteredDrivers = Array.isArray(drivers)
        ? drivers.filter(driver =>
            driver.driver_name.toLowerCase().includes(searchQuery.toLowerCase())
        )
        : [];

    const driverOptions = filteredDrivers.map(driver => ({
        value: driver.driver_id,
        label: `${driver.driver_id} - ${driver.driver_name}`
    }));

    const buttonsyle = {
        background: '#00a6ed',
        color: '#fff',
        padding: '3px',
        marginRight: '10px',
        borderColor: '#00a6ed',
        cursor: 'pointer',
        marginTop: '3%'
    }




  

    const [scaninfo, setScaninfo] = useState({
       
    })


    const handleChange = (selectedOption) => {
        const selectedDriverId = selectedOption.value;  // Get driver ID
        const selectedDriverName = selectedOption.label;  // Get driver name
        // Call the function with both driver ID and name
        setScaninfo({ ...scaninfo, driverId: selectedOption.value })
    };


   function saveAttendance() {
    console.log('scaninfo:', scaninfo);

    const requestData = {
        driverId: scaninfo.driverId ,  // Use driverId from scaninfo or default to 30
        checkInDateTime: `${scaninfo.checkInDateTime}T${scaninfo.checkinTime}:00`,  // Format check-in date-time
        checkOutDateTime: `${scaninfo.checkOutDateTime}T${scaninfo.checkoutTime}:00`,  // Format check-out date-time
        checkInWarehouseId: scaninfo.checkInWarehouseId[0],  // Use first element in array, fallback to 4
        checkOutWarehouseId: scaninfo.checkOutWarehouseId[0],  // Use first element in array, fallback to 5
        checkInLocation: "",  // Static location, adjust if needed
        checkOutLocation: "",  // Static location, adjust if needed
    };

    axios.post( `${API_URL}shypvdriverapp/driver-attendance/manual`, requestData, {
        headers: {
            'Content-Type': 'application/json',
        },
    })
    .then(response => {
        if(response.data.success){
            setMsg('Attendance saved successfully')
            setScaninfo({})
        console.log('Attendance saved successfully:', response.data);
        }
    })
    .catch(error => {
        console.error('Error saving attendance:', error);
    });
}

    return (
        <div>

            <div className="container">
                <div className="form-container">
                    <div className="row">
                        <div className="col-md-5">
                            <h5 style={{ float: 'left' }}>Add Driver Attendance </h5>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-md-5">


                            <div className="form-group">
                                <label htmlFor="formGroupExampleInput2" className="m-form">Driver*</label>


                                <Select
                                    options={driverOptions}
                                    value={driverOptions.find(option => option.value === scaninfo.driver) || ''}
                                    onChange={handleChange}
                                    placeholder="Select a driver"
                                    onInputChange={newValue => setSearchQuery(newValue)} // Update search query
                                    isSearchable
                                    noOptionsMessage={() => "No drivers found"}
                                />

                            </div>

                        </div>




                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="col-md-5">
                                <div className="form-group">
                                    <label htmlFor="date">Checkin Date:</label>
                                    <input
                                        type="date"
                                        id="date"
                                        onChange={(e) => setScaninfo({ ...scaninfo, checkInDateTime: e.target.value })}
                                        value={scaninfo.checkInDateTime || ''}

                                    />
                                </div>
                            </div>
                            <div className="col-md-5">
                                {/* Time Input */}
                                <div className="form-group">
                                    <label htmlFor="time">Checkin Time:</label>
                                    <input
                                        type="time"
                                        id="time"
                                        onChange={(e) => setScaninfo({ ...scaninfo, checkinTime: e.target.value })}
                                        value={scaninfo.checkinTime || ''}

                                    />
                                </div>

                            </div>
                        </div>


                    </div>

                    <div className="row">
                        <div className="col-md-5">
                            <div className="form-group">
                                <label htmlFor="date">Checkout Date:</label>
                                <input
                                    type="date"
                                    id="date"
                                    onChange={(e) => setScaninfo({ ...scaninfo, checkOutDateTime: e.target.value })}
                                    value={scaninfo.checkOutDateTime || ''}

                                />
                            </div>
                        </div>
                        <div className="col-md-5">
                            {/* Time Input */}
                            <div className="form-group">
                                <label htmlFor="time">Checkout Time:</label>
                                <input
                                    type="time"
                                    id="time"
                                    onChange={(e) => setScaninfo({ ...scaninfo, checkoutTime: e.target.value })}
                                    value={scaninfo.checkoutTime || ''}

                                />
                            </div>

                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-5">
                            <div className="form-group">
                                <label htmlFor="formGroupExampleInput2" className="m-form">
                                    Checkin Location
                                </label>

                                <Select
    options={locationOptions}
    value={
        locationOptions.filter(option =>
            scaninfo?.checkInWarehouseId?.includes(option.value)
        ) || []
    }
    onChange={(selectedOptions) => {
        // Ensure selectedOptions is always an array (even for single selection)
        const selectedValues = Array.isArray(selectedOptions)
            ? selectedOptions.map(option => option.value)
            : selectedOptions
            ? [selectedOptions.value] // Single selection case
            : [];

        setScaninfo({ ...scaninfo, checkInWarehouseId: selectedValues });
    }}
    placeholder="Select locations"
    isSearchable
    noOptionsMessage={() => "No locations found"}
/>


                            </div>


                        </div>
                        <div className="col-md-5">
                            <div className="form-group">
                                <label htmlFor="formGroupExampleInput2" className="m-form">
                                    Checkout Location
                                </label>

                                <Select
                                    options={locationOptions}
                                    value={
                                        locationOptions.filter(option =>
                                            scaninfo?.checkOutWarehouseId?.includes(option.value)
                                        ) || []
                                    }
                                    onChange={(selectedOptions) => {
                                        // Ensure selectedOptions is always an array (even for single selection)
                                        const selectedValues = Array.isArray(selectedOptions)
                                            ? selectedOptions.map(option => option.value)
                                            : selectedOptions
                                                ? [selectedOptions.value] // Single selection case
                                                : [];

                                        setScaninfo({ ...scaninfo, checkOutWarehouseId: selectedValues });
                                    }}
                                    placeholder="Select locations"
                                    isSearchable
                                    noOptionsMessage={() => "No locations found"}
                                />


                            </div>


                        </div>


                    </div>



                    <a onClick={saveAttendance} style={buttonsyle} type="button" className="btn-demo add">
                        Submit
                    </a>
                    <p>{errormsg}</p>
                    <p>{msg}</p>

                </div>
            </div>
        </div>
    )
}
